<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-address" scrollable centered button-size="sm">
      <template #modal-title>
       <i class="fas fa-map-marker-alt"></i> NOVO LOGRADOURO
      </template>
      <div class="pb-4">
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label for="txtGroup"><small class="text-danger" v-if="form.cep.required">*</small> CEP:</label>
            <div class="input-group">
              <b-form-input type="text"
                          v-model="form.cep.value"
                          :required="form.cep.required"
                          :state="form.cep.state"
                          v-mask="[ '#####-###']"
                          @change="onSearchCep"/>
              <span class="input-group-addon"><i class="fa fa-search"></i></span>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label for="txtGroup"><small class="text-danger" v-if="form.endereco.required">*</small> Endereço:</label>
            <div class="input-group">
              <b-form-input type="text"
                          v-model="form.endereco.value"
                          :required="form.endereco.required"
                          :state="form.endereco.state"/>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label for="txtGroup"><small class="text-danger" v-if="form.bairro.required">*</small> Bairro:</label>
            <div class="input-group">
              <b-form-input type="text"
                          v-model="form.bairro.value"
                          :required="form.bairro.required"
                          :state="form.bairro.state"/>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-3">
            <label for="txtGroup"><small class="text-danger" v-if="form.uf.required">*</small> Estado:</label>
            <div class="input-group">
              <b-form-input type="text"
                          v-model="form.uf.value"
                          :required="form.uf.required"
                          :state="form.uf.state"/>
            </div>
          </div>
          <div class="col-md-9">
            <label for="txtGroup"><small class="text-danger" v-if="form.municipio.required">*</small> Cidade:</label>
            <div class="input-group">
              <b-form-input type="text"
                          v-model="form.municipio.value"
                          :required="form.municipio.required"
                          :state="form.municipio.state"/>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-3">
            <label for="txtGroup"><small class="text-danger" v-if="form.numero.required">*</small> Número:</label>
            <div class="input-group">
              <b-form-input type="text" ref="number"
                          v-model="form.numero.value"
                          :required="form.numero.required"
                          :state="form.numero.state"/>
            </div>
          </div>
          <div class="col-md-9">
            <label for="txtGroup"><small class="text-danger" v-if="form.complemento.required">*</small> Complemento:</label>
            <div class="input-group">
              <b-form-input type="text"
                          v-model="form.complemento.value"
                          :required="form.complemento.required"
                          :state="form.complemento.state"/>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button @click.prevent="onSave" type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Salvar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import AddressModal from './addressmodal.js'
export default AddressModal
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/addresses/modal/addressmodal.vue